module.exports = __webpack_public_path__ + "static/media/cloak.dbab02d0.svg";